import ScalarCard_vue_vue_type_script_setup_true_lang_default from "./ScalarCard.vue.script.js";
//#region src/components/ScalarCard/ScalarCard.vue
var ScalarCard_default = ScalarCard_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCard_default as default };

//# sourceMappingURL=ScalarCard.vue.js.map